import { render, staticRenderFns } from "./TreatmentTimeline.vue?vue&type=template&id=c8bc27a0"
import script from "./TreatmentTimeline.vue?vue&type=script&lang=js"
export * from "./TreatmentTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports